import React from "react";
import { createRenderExtension } from "./base";
import { Hr } from "../styled";

export const extThematicBreak = createRenderExtension({
  renderContent(_controller, content, next) {
    if (content.type === "thematicBreak") {
      return <Hr />;
    }
    return next();
  },
});
